import {
  CHAT_TYPE,
  IGroupInfo,
  IInfoType,
  IPendingReferral,
} from "@home-health-notify/domain";
import { Tooltip } from "@mui/material";
import {
  IChatAccess,
  sortByDate,
  UserDirectoryContext,
  useTranslation,
} from "hhn-commons";
import { useContext } from "react";
import PendingReferralIcon from "../../common/PendingReferralIcon";
import {
  PendingReferralsText,
  PendingReferralWrapper,
} from "../MessagePanel.style";

export const PendingReferralStrip = ({
  chatAccess,
}: {
  chatAccess: IChatAccess;
}) => {
  const chatData: IInfoType = chatAccess.chatInfo;
  const { t } = useTranslation();
  const { userDirectory } = useContext(UserDirectoryContext);

  const referrals: IPendingReferral[] =
    (chatData as IGroupInfo).pendingReferrals ?? [];

  const MAX_VISIBLE_NAMES = 5;

  const allNames = sortByDate<IPendingReferral>([...referrals]).map(
    referral => userDirectory.getUserInfo(referral.userId).firstName,
  );
  const visibleNames = allNames.slice(0, MAX_VISIBLE_NAMES).join(", ");
  const fullNames = allNames.join(", ");
  const hiddenNamesCount = Math.max(allNames.length - MAX_VISIBLE_NAMES, 0);
  const hasHiddenNames = hiddenNamesCount > 0;

  const tNs = (key: string) =>
    t(key, {
      ns: "message",
      pendingReferralCount: referrals.length,
      moreCount: hiddenNamesCount,
    });

  return (
    <>
      {chatAccess.getChatType() === CHAT_TYPE.GROUP && referrals.length > 0 && (
        <PendingReferralWrapper>
          <PendingReferralIcon size={18} />
          <Tooltip title={fullNames}>
            <PendingReferralsText variant="body1">
              {tNs("pendingReferrals")} - {visibleNames}
              {hasHiddenNames && ` ${tNs("pendingReferralsAndMore")}`}
            </PendingReferralsText>
          </Tooltip>
        </PendingReferralWrapper>
      )}
    </>
  );
};
